import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    name: '',
    document: '',
    phone: '',
    email: '',
    loading: false
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/cantAccess/index.js